module.exports = __webpack_public_path__ + "img/assist.9d09d526.svg";